module.exports = __webpack_public_path__ + "img/x4.af85a8ba.jpg";